export const MAX_MINT_COUNT = 100
export const CHAIN_ID = 43114
// export const RPC_URL = "https://rpc.ankr.com/arbitrum" https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161
export const RPC_URL = "https://avalanche-mainnet.infura.io/v3/cc763a942c5742f68a0500a2acac5e69"
export const INFURA_ID = "Q58A3YC3F7MCIA49683682D8TZYERDRYZ2"
export const GAS_LIMIT = 300000